import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Breadcrumb from "@/components/Breadcrumb";
import SchemaMarkup from "@/components/SchemaMarkup";
import { testimonials } from "@/mocks/testimonials";
import { categories } from "@/mocks/categories";
import { useState } from "react";

export default function AboutPage() {
  const [testimonialIdx, setTestimonialIdx] = useState(0);

  return (
    <>
      <SchemaMarkup
        type="WebPage"
        data={{
          name: "关于我们 - 91EatGossip",
          description:
            "了解91EatGossip的品牌故事、信誉背书与联系方式。我们是最专业的中文娱乐八卦资讯门户。",
          url: "http://msldyun.cn/about",
        }}
      />
      <SchemaMarkup
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: "http://msldyun.cn/" },
            { "@type": "ListItem", position: 2, name: "关于我们", item: "http://msldyun.cn/about" },
          ],
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1 pt-20">
          <section className="relative min-h-[400px] md:min-h-[500px] flex items-center">
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 min-h-[400px] md:min-h-[500px]">
              <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-0 order-2 lg:order-1 bg-background-50">
                <div className="max-w-xl">
                  <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "关于我们" }]} />
                  <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mt-6 mb-4">
                    关于
                    <br />
                    91EatGossip
                  </h1>
                  <p className="text-base text-foreground-600 leading-relaxed mb-6 max-w-md">
                    91EatGossip致力于打造最专业的中文娱乐八卦资讯平台，让每一个吃瓜群众都能第一时间获取最真实、最劲爆的娱乐内幕。
                  </p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-3 bg-foreground-900 text-background-50 px-6 py-3.5 text-sm font-medium uppercase tracking-wide hover:bg-foreground-800 transition-colors group"
                  >
                    开始吃瓜
                    <span className="w-8 h-8 border border-background-400 flex items-center justify-center group-hover:border-background-200 transition-colors">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </Link>
                </div>
              </div>
              <div className="relative order-1 lg:order-2 min-h-[250px] lg:min-h-[500px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20workspace%20with%20warm%20wooden%20desks%20and%20soft%20ambient%20lighting%2C%20multiple%20computer%20screens%20showing%20news%20content%2C%20behind%20the%20scenes%20documentary%20photography%2C%20warm%20amber%20golden%20tones%20with%20dark%20moody%20shadows%2C%20editorial%20cinematic%20style&width=1200&height=900&seq=about-hero-01&orientation=landscape"
                  alt="91EatGossip 团队工作场景"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-background-50/50 via-transparent to-transparent lg:block hidden" />
              </div>
            </div>
          </section>

          <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-4xl mx-auto">
              <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
                品牌故事
              </p>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
                从一间出租屋
                <br />
                到千万级八卦门户
              </h2>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6">
                91EatGossip成立于2018年，创始团队是一群热爱娱乐新闻的资深媒体人。我们从一间小小的出租屋起步，凭借着对真相的执着追求和敏锐的嗅觉，逐步成长为中文互联网最具影响力的娱乐八卦资讯门户之一。
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6">
                六年来，我们累计发布了超过10000篇独家爆料，其中超过80%的内容后续得到了官方或当事人的证实。从明星出轨到网红翻车，从综艺黑幕到影视内幕，我们的身影始终出现在每一个重大娱乐新闻的第一现场。
              </p>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10">
                我们的信条很简单：用事实说话，用证据吃瓜。每一篇爆料都经过至少两个独立信源的交叉验证，绝不编造、绝不跟风、绝不妥协。这就是为什么数百万读者选择信任91EatGossip，每天在这里获取最新、最真实的娱乐资讯。
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Small%20startup%20office%20interior%20with%20warm%20wooden%20furniture%20and%20soft%20natural%20lighting%20through%20windows%2C%20cozy%20creative%20workspace%20photography%2C%20warm%20amber%20tones%20with%20dark%20moody%20shadows%2C%20editorial%20documentary%20style&width=600&height=400&seq=about-img-01&orientation=landscape"
                  alt="91EatGossip 初创时期办公室"
                  className="w-full h-64 object-cover rounded-lg"
                  loading="lazy"
                />
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20journalists%20working%20at%20desks%20computer%20screens%20showing%20breaking%20news%2C%20behind%20the%20scenes%20documentary%20photography%2C%20warm%20ambient%20lighting%20with%20dramatic%20golden%20tones%20against%20dark%20background%2C%20editorial%20cinematic%20style&width=600&height=400&seq=about-img-02&orientation=landscape"
                  alt="91EatGossip 现代新闻编辑部"
                  className="w-full h-64 object-cover rounded-lg"
                  loading="lazy"
                />
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-7xl mx-auto">
              <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
                核心优势
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-12 md:mb-16">
                为什么选择
                <br />
                91EatGossip
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {[
                  {
                    icon: "ri-time-line",
                    title: "24小时不间断",
                    desc: "全年无休实时更新，重大爆料分钟级推送，确保您永远领先一步获取最新资讯。",
                  },
                  {
                    icon: "ri-hd-line",
                    title: "高清独家视频",
                    desc: "独家偷拍视频、现场监控画面、录音证据均以高清画质呈现，细节清晰可见。",
                  },
                  {
                    icon: "ri-shield-check-line",
                    title: "严格信源审核",
                    desc: "每条爆料均经过至少两个独立信源交叉验证，附完整证据链，拒绝捕风捉影。",
                  },
                  {
                    icon: "ri-vip-crown-line",
                    title: "资深爆料团队",
                    desc: "核心团队成员均来自一线娱乐媒体，拥有超过10年从业经验，人脉资源遍布业内。",
                  },
                  {
                    icon: "ri-global-line",
                    title: "全网覆盖追踪",
                    desc: "覆盖全网公开平台热点，多维度追踪事件发酵全过程。",
                  },
                  {
                    icon: "ri-lock-unlock-line",
                    title: "永久免费观看",
                    desc: "所有视频和文章内容完全免费，无需注册、无需付费，坚持吃瓜自由理念。",
                  },
                ].map((item) => (
                  <div
                    key={item.title}
                    className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70"
                  >
                    <div className="w-10 h-10 flex items-center justify-center mb-4">
                      <i className={`${item.icon} text-2xl text-foreground-700`} />
                    </div>
                    <h3 className="text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-3xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10">
                （媒体认可）
              </h2>
              <div className="text-left">
                <div className="flex items-center gap-2 mb-6">
                  <div className="px-3 py-1.5 bg-foreground-900 text-background-50 rounded-full text-xs font-medium flex items-center gap-1.5">
                    <i className="ri-star-fill text-accent-500" />
                    <span>{testimonials[testimonialIdx].rating}</span>
                  </div>
                </div>
                <blockquote className="font-heading text-lg text-foreground-800 leading-relaxed mb-8">
                  &ldquo;{testimonials[testimonialIdx].quote}&rdquo;
                </blockquote>
                <div className="flex items-center gap-3">
                  <img
                    src={testimonials[testimonialIdx].avatar}
                    alt={testimonials[testimonialIdx].author}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">
                      {testimonials[testimonialIdx].author}
                    </p>
                    <p className="text-xs text-foreground-500">
                      {testimonials[testimonialIdx].role}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-end gap-2 mt-8">
                <button
                  onClick={() =>
                    setTestimonialIdx((i) => (i === 0 ? testimonials.length - 1 : i - 1))
                  }
                  className="w-10 h-10 border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line" />
                </button>
                <button
                  onClick={() =>
                    setTestimonialIdx((i) => (i === testimonials.length - 1 ? 0 : i + 1))
                  }
                  className="w-10 h-10 bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </section>

          <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
            <div className="w-full max-w-4xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
                  数据统计
                </p>
                <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                  用数字说话
                </h2>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                {[
                  { value: "10,000+", label: "独家爆料" },
                  { value: "80%", label: "爆料证实率" },
                  { value: "500万", label: "月活用户" },
                  { value: "6年", label: "持续运营" },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                      {stat.value}
                    </p>
                    <p className="text-sm text-foreground-600">{stat.label}</p>
                  </div>
                ))}
              </div>

              <div className="mt-12 pt-8 border-t border-background-200/70">
                <h3 className="text-lg font-semibold text-foreground-900 mb-4 text-center">
                  联系我们
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                  <div>
                    <p className="text-xs uppercase tracking-wider text-foreground-500 mb-1">爆料邮箱</p>
                    <p className="text-sm text-foreground-700">hello@msldyun.cn</p>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-foreground-500 mb-1">商务合作</p>
                    <p className="text-sm text-foreground-700">hello@msldyun.cn</p>
                  </div>
                  <div>
                    <p className="text-xs uppercase tracking-wider text-foreground-500 mb-1">意见反馈</p>
                    <p className="text-sm text-foreground-700">hello@msldyun.cn</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}
